'use strict';

import $ from 'jquery';
import popup from './popup';

let orderNewsletterPopup = {

  lang: null,
  $submitButtons: null,
  $invalidFields: [],
  fieldValidationRules: {
    'firstname': function(value){
      return value.length > 1;
    },
    'lastname': function(value){
      return value.length > 1;
    },
    'email': function(value){
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(value).toLowerCase());
    },
  },

  initOrderNewsletter: function(){
    var self = this;

    for(var fieldName in this.fieldValidationRules){
      var $field = popup.$content.find('[name="'+fieldName+'"]');
      $field.on('keyup', function(){ // jshint ignore:line
        self.validateForm();
      });
    }

    this.$submitButtons = popup.$content.find('[data-newsletter-submit]');
    this.$submitButtons.on('click', function(evt){
      evt.preventDefault();
      self.submitForm();
    });

    popup.$content.find('input').filter(':visible').first().focus();
  },

  validateForm: function(){
    this.$invalidFields = [];
    this.$submitButtons.attr('disabled', 'disabled');
    for(var fieldName in this.fieldValidationRules){
      var $field = popup.$content.find('[name="'+fieldName+'"]');
      if(this.fieldValidationRules[fieldName]($field.val()) !== true){
        this.$invalidFields.push($field);
      }
    }
    if(this.$invalidFields.length === 0){
      // No invalid fields
      this.$submitButtons.removeAttr('disabled');
      return true;
    }
    return false;
  },

  setMessage: function(message){
    var $message = popup.$content.find('[data-newsletter-message]');
    $message.empty();
    if(message){
      $message.append($('<div class="alert-danger p1 my1">'+message+'</div>'));
    }
  },

  submitForm: function(){
    var self = this;

    if(!this.validateForm()){
      // form is not valid
      console.log('Order newsletter: form not valid, not submitted...');
      return;
    }

    // Hide submit, show loader
    this.$submitButtons.hide();
    popup.$content.find('[data-newsletter-loader]').show();

    $.ajax({
      url: '/stage-ajax/order-newsletter/subscribe?stage-language='+this.lang,
      data: {
        'firstname': popup.$content.find('[name="firstname"]').val(),
        'lastname': popup.$content.find('[name="lastname"]').val(),
        'email': popup.$content.find('[name="email"]').val(),
        'fill_your_email': popup.$content.find('[name="fill_your_email"]').val(), // honeypot field
        'token': popup.$content.find('[name="token"]').val(),
      },
      method: 'POST',
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        // HTTP error
        self.setMessage('Network error. Please reload the page and try again.');
        popup.$content.find('[data-newsletter-loader]').hide();
        self.$submitButtons.hide();
        console.log('Order newsletter: form submit failed', textStatus, errorThrown);
      },
      success: function(data){
        if(!data.success){
          // submit has error
          if(data.newToken){
            // Set new token
            popup.$content.find('[name="token"]').val(data.newToken);
          }

          if(data.message){
            self.setMessage(data.message);
          }

          // Hide loader, show submit
          popup.$content.find('[data-newsletter-loader]').hide();
          self.$submitButtons.show();

        } else {
          popup.setView('success');
          // Clear the form
          popup.$content.find('[name="firstname"]').val('');
          popup.$content.find('[name="lastname"]').val('');
          popup.$content.find('[name="email"]').val('');
          //console.log('Order newsletter: form submit succeed', data);

          if(window.location.host.indexOf('stage.crasman.fi') < 0){
            // Not in admin > Push event to dataLayer
            if(window.dataLayer){
              const dlObject = {
                'event': 'dlToAnalytics',
                'eventCategory': 'Form',
                'eventAction': 'Submit',
                'eventLabel': 'Newsletter form subscription 2021'
              };
              window.dataLayer.push(dlObject);
            }
          }

        }
      },
    });
  },

  openOrderNewsletterPopup: function(){
    var self = this;
    popup.openPopup('/stage-ajax/order-newsletter/popup?stage-language='+this.lang, function(){
      self.initOrderNewsletter();
    });
  },

  init: function(){
    //console.log('Order newsletter: init');

    this.$triggers = $('[data-order-newsletter-popup-trigger]');

    if(this.$triggers.length){
      var self = this;
      this.lang = $('html').attr('lang').replace('-', '_');
      this.$triggers.on('click', function(evt){
        evt.preventDefault();
        self.openOrderNewsletterPopup();
      });
    }

  } // init()

};

export default orderNewsletterPopup;
